<template>
    <div v-if="isVisible" class="form-item" :class="[isInvalid ? 'is-invalid' : '']">
        <Label :item="item"
               :is-invalid="isInvalid"
               :errors="errors"/>

        <div class="scale">
            <div
                v-for="n in Number(item.data.scaleSteps)"
                :key="n"
                :class="{active: n == selected}"
                @click="select(n)">
                {{ n }}
            </div>
        </div>

        <input type="hidden" :name="item.data.id" :value="selected" />
    </div>
</template>

<script>
import Label from "../components/Label.vue";

import errorMixin from "../mixins/error";
import logicMixin from "../mixins/logic";

export default {
    name: 'Numericscale',
    mixins: [ errorMixin, logicMixin ],
    components: { Label },
    props: {
        item: {
            type: Object
        }
    },
    data: function() {
        return {
            selected: this.item.data.scaledefaultselected ? Number(this.item.data.scaledefaultselected) : null
        };
    },
    methods: {
        select(n) {
            this.selected = n;
        },
    }
};
</script>

<style lang="scss" scoped>
.scale {
    display: flex;

    > div {
        min-width: 50px;
        height: 50px;
        border-width: 1px;
        border-right-width: 0;
        border-style: solid;
        border-color: #939393;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &:last-child {
            border-right-width: 1px;
        }

        &:hover, &.active {
            background-color: var(--primary);
            color: #fff;
        }
    }
}
</style>